import { logout } from "./auth/auth.service";
import { baseUrl } from "./constants";

export const httpRequest = async ({ route, headers, method = "GET", body, params }) => {
  const auth = getAuth();
  const requestHeaders = {
    ...auth,
  };

  if (!(body instanceof FormData)) {
    requestHeaders["Content-Type"] = "application/json";
  }

  if (headers) {
    Object.keys(headers).forEach((key) => {
      requestHeaders[key] = headers[key];
    });
  }

  if (params) {
    const paramsString = Object.keys(params)
      .filter((key) => params[key])
      .map((key) =>
        Array.isArray(params[key])
          ? params[key].map((value) => `${key}=${value}`).join("&")
          : `${key}=${params[key]}`
      )
      .join("&");
    route = `${route}?${paramsString}`;
  }

  const response = await fetch(`${baseUrl}/${route}`, {
    method,
    headers: requestHeaders,
    ...(body ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {}),
  });

  const result = await response.json();

  if (result?.statusCode === 401) {
    logout();
  }

  return result;
};

const getAuth = () => {
  const session = JSON.parse(localStorage.getItem('session'));
  return {
    user_token: session.token,
    user_id: session.userId,
    customer_id: session.customerId,
  };
};
